import { ReactElement } from 'react'
import { defaultTheme } from 'src/theme'
import { breakpoints } from 'src/theme/breakpoints'
import styled from 'styled-components'
import Item from './Item'

interface Item {
  text: string
  action?: () => void
}

interface Props {
  items: Item[]
}

const Breadcrumb = (props: Props): ReactElement => {
  const { items } = props
  return (
    <Wrapper>
      {items.map((item, index) => (
        <Flex key={`breadcrumb_item_${item.text}_${index}`}>
          <Item {...item} />
          {index < items.length - 1 && <Divider>|</Divider>}
        </Flex>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: ${breakpoints.tabletLarge}px) {
    display: none;
  }
  margin: 0.3rem 0rem 0.3rem 0rem;
`

const Flex = styled.div`
  display: flex;
`

const Divider = styled.span`
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  color: ${defaultTheme.colors.borderTable};
`

export default Breadcrumb
